import {createSlice, type PayloadAction} from "@reduxjs/toolkit";
import {type Catalog} from "../model/product/Catalog";
import {authReducerActions} from "./authReducer.ts";

// Catalog/garage selection is kept in Redux + persist on purpose: it is
// cross-page navigation context (the user expects to come back to the same
// catalog after navigating into a detail page). The active overview filter is
// the same kind of context but session-scoped — it lives in the separate
// `overviewFilters` slice. Pagination/sort live in the URL — see M6.
export interface ProductState {
    selectedCatalogNo: string | null;
    selectedCatalog: Catalog | null;
    selectedGarageNo: string | null;
}

const initialState: ProductState = {
    selectedCatalogNo: null,
    selectedCatalog: null,
    selectedGarageNo: null,
};

export const productSlice = createSlice({
    name: "products",
    initialState,
    reducers: {
        setSelectedGarageNo: (state, action: PayloadAction<string | null>) => {
            state.selectedGarageNo = action.payload;
        },
        setSelectedCatalog: (state, action: PayloadAction<Catalog>) => {
            const catalog = action.payload;
            state.selectedCatalogNo = catalog.catalogNo.catalogNo.index;
            state.selectedCatalog = catalog;
            state.selectedGarageNo = catalog.garageNo.index;
        },
    },
    extraReducers: builder => {
        builder.addCase(authReducerActions.logoutSuccess, state => {
            state.selectedCatalogNo = null;
            state.selectedCatalog = null;
            state.selectedGarageNo = null;
        });
        // a catalog of one garage must not stick when support switches to another
        builder.addMatcher(
            action => authReducerActions.startSupportContext.match(action) || authReducerActions.endSupportContext.match(action),
            state => {
                state.selectedCatalogNo = null;
                state.selectedCatalog = null;
                state.selectedGarageNo = null;
            },
        );
    },
});

export const productReducerActions = productSlice.actions;
export default productSlice.reducer;
